import { render, staticRenderFns } from "./NmtSidebarProfileChartDialog.vue?vue&type=template&id=5e88f494&scoped=true&"
import script from "./NmtSidebarProfileChartDialog.vue?vue&type=script&lang=js&"
export * from "./NmtSidebarProfileChartDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88f494",
  null
  
)

export default component.exports